import axios from "axios"
import { parkingState } from "../zustand/parkingState" // Adjust the import path as needed
import * as endpoint from "../constants/Endpoints" // Adjust the import path as needed
import * as path from "../constants/Paths" // Adjust the import path as needed
import config from "react-global-configuration"
import Sticky from "../../styleguide/js/components/sticky"
import { DateTime } from "luxon"
import * as cookieHelper from "../../helpers/cookie"
import { sort, amendmentSorting, spacesSorting } from "./sortingHelper"
import * as storageHelper from "../../helpers/storageHelper"
import { RedirectCheckout } from "@bambora/checkout-sdk-web"
import Wallet from "@bambora/wallet"
import * as tracking from "../helpers/tracking"
import { FlowEnum } from "../constants/flowEnums"

const saveGuidToSessionStorage = (res) => {
  sessionStorage.setItem("CPH:BOOKING_GUID", res.booking.guid)
}

const getArrivalData = () => {
  const { arrivalDate, arrivalTime } = parkingState.getState()
  if (!arrivalDate || !arrivalTime) return null
  return `${arrivalDate} ${arrivalTime}`
}

const getDepartureData = () => {
  const { departureDate, departureTime } = parkingState.getState()
  if (!departureDate || !departureTime) return null
  return `${departureDate} ${departureTime}`
}

const genericModalOpen = (html) => {
  parkingState.setState({
    genericModalActive: true,
    genericModalBody: html,
    genericModalCallback: null,
  })
}
const setGlobalState = (state, callback) => {
  parkingState.setState(state)
  if (callback) callback()
}

export const createQueryStrings = (data) => {
  let queryString = ""
  if (!data) return queryString
  Object.keys(data).forEach((key) => {
    const operator = queryString ? "&" : "?"
    if (data[key]) queryString += `${operator}${key}=${data[key]}`
  })
  return queryString
}

const trackError = (text, error, errorType) => {
  const userId = cookieHelper.getUserId()

  const data = {
    event: "track-event",
    eventCategory: "parking flow",
    eventAction: "error",
    eventLabel: getErrorLabel(error, errorType, text),
    eventValue: 0,
    eventNoninteraction: true,
    userParkingArrivalDate: parkingState.getState().arrivalDate,
    userParkingDepartureDate: parkingState.getState().departureDate,
    pageBusinessunit: "parking",
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}

const trackSoldOutRate = (allProducts) => {
  const { arrivalDate, departureDate } = parkingState.getState()
  const amountOfProducts = allProducts.length
  let amountOfSoldOutProducts = 0
  allProducts.forEach((item) => {
    if (item.product.isSoldOut) {
      amountOfSoldOutProducts++
    }
  })
  const userId = cookieHelper.getUserId()
  const data = {
    event: "track-event",
    eventCategory: "parking flow",
    eventAction: "sold out rate",
    eventLabel: `${amountOfSoldOutProducts}/${amountOfProducts}`,
    eventValue: parseFloat(amountOfSoldOutProducts / amountOfProducts).toFixed(2),
    eventNoninteraction: true,
    userParkingArrivalDate: arrivalDate,
    userParkingDepartureDate: departureDate,
    pageBusinessunit: "parking",
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}
const getErrorLabel = (error, errorType, text) => {
  switch (errorType) {
    case "search":
      return `search - ${text}`
    case "extra services":
      return `extra services - ${text}`
    case "payment":
      return `payment - ${text}`
    case "payment gateway":
      return `payment gateway - ${text}`
    case "date":
      return `date - ${text}`
    default:
      return error
  }
}
export const axiosErrorHandler = (error, errorState = {}, errorHandlers = {}) => {
  console.log("axiosErrorHandler", error)
  const textKeys = config.get("textKeys.dialog") || {}
  if (!error.response) {
    const text = textKeys.unknownError || `<h3>Fejl</h3><p>Der er sket en uventet fejl</p>`
    parkingState.setState(errorState, errorHandlers.noResponse ? errorHandlers.noResponse(error.response?.data) : genericModalOpen(text))
    return text
  }

  // parse by code

  if (error.response.status === 400) {
    const text =
      (textKeys.badRequestError && textKeys.badRequestError.replace("${", "{").replace("{message}", error.response.data.message)) ||
      `<h3>Fejl</h3><p>${error.response.data.message}</p>`

    parkingState.setState(errorState)
    errorHandlers.badRequest ? errorHandlers.badRequest(error.response.data.message) : genericModalOpen(text)
    return text
  }

  /* old message string based error handling*/

  if (error.response.status === 404 || (error.response.data && error.response.data.message === "NotFound")) {
    const text = textKeys.notFoundError || `<h3>Fejl</h3><p>Der er en fejl i linket, hvis du har kopieret det ind så prøv igen</p>`
    parkingState.setState(errorState)
    errorHandlers.notFound ? errorHandlers.notFound(error.response.data) : genericModalOpen(text)
    return text
  }

  if (error.response.status === 405 || (error.response.data && error.response.data.message === "MethodNotAllowed")) {
    const text =
      textKeys.sessionExpiredError ||
      `<h3>Fejl</h3><p>Din session er udløbet du har været inaktiv for længe, prøv at genindlæse siden ved at trykke på CTRL+R</p>`
    parkingState.setState(errorState)
    errorHandlers.methodNotAllowed ? errorHandlers.methodNotAllowed(error.response.data) : genericModalOpen(text)

    return text
  }

  console.log(JSON.stringify(error))
  if (error.response && error.response.data.message && error.response.data.message) {
    const text =
      (textKeys.standardError && textKeys.standardError.replace("${", "{").replace("{message}", error.response.data.message)) ||
      `<h3>Fejl</h3><p>${error.response.data.message}</p>`
    genericModalOpen(text)
  }
  parkingState.setState(errorState)
}
export const resendNextAvailableBookingConfirmation = (email) => {
  if (!parkingState.getState().loadingresendNextAvailableBookingConfirmation) {
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingresendNextAvailableBookingConfirmation: true,
        loadingresendNextAvailableBookingConfirmationError: undefined,
      },
      () => {
        axios
          .get(endpoint.RESEND_NEXT_AVAILABLE_BOOKING_CONFIRMATION() + "?email=" + email)
          .then((res) => res.data)
          .then(() => {
            genericModalOpen(
              (config.get("textKeys.dialog.emailActivation") &&
                config.get("textKeys.dialog.emailActivation").replace("${", "{").replace("{email}", email)) ||
                `<h3>Genfremsendelse aktiveret</h3><p>Du vil i løbet af et par minutter modtage en ny kopi af alle fremtidige bookinger foretaget af <strong>${email}</strong></p>`,
            )
            parkingState.setState({
              ajaxSpinnerActive: false,
              forgotReferenceModalActive: false,
              loadingresendNextAvailableBookingConfirmation: false,
              loadingresendNextAvailableBookingConfirmationError: undefined,
            })
          })
          .catch((error) => {
            axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingresendNextAvailableBookingConfirmation: false,
              loadingresendNextAvailableBookingConfirmationError: error,
            })
          })
      },
    )
  }
}
export const resendBookingReceipt = (guid) => {
  if (!parkingState.getState().loadingResendBookingReceipt) {
    const email = parkingState.getState().manageBookingResult?.booking?.email
    let modalText =
      config.get("textKeys.dialog.emailResendReceipt") ||
      `<h3>Genfremsendelse aktiveret</h3><p>Du vil i løbet af et par minutter modtage en ny kopi af din kvitteringsmail</p>`
    modalText = modalText.formatUnicorn({ email: email })
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingResendBookingReceipt: true,
        loadingResendBookingReceiptError: undefined,
      },
      () => {
        axios
          .get(endpoint.RESEND_BOOKING_RECEIPT(guid))
          .then((res) => res.data)
          .then(() => {
            genericModalOpen(modalText)
            parkingState.setState({
              ajaxSpinnerActive: false,
              forgotReferenceModalActive: false,
              loadingResendBookingReceipt: false,
              loadingResendBookingReceiptError: undefined,
            })
          })
          .catch((error) => {
            axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingResendBookingReceipt: false,
              loadingResendBookingReceiptError: error,
            })
          })
      },
    )
  }
}
export const performChangeBookingSearch = (
  changeFromBookingResult,
  arrivalDate,
  arrivalTime,
  departureDate,
  departureTime,
  voucher = "",
  affiliateCode = "",
  reference,
  email,
  replaceHistory,
  sorting = "",
  history,
) => {
  if (!parkingState.getState().loadingPerformChangeBookingSearch) {
    const changeFromBookingGuid = changeFromBookingResult?.booking?.guid
    if (!changeFromBookingGuid) {
      console.log("No changeFromBookingGuid")
      return
    }
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingPerformChangeBookingSearch: true,
        loadingPerformChangeBookingSearchError: undefined,
      },
      () => {
        console.debug("performChangeBookingSearch")
        axios
          .get(
            endpoint.FIND_PARKING_CHANGE(changeFromBookingGuid) +
              "?arrival=" +
              encodeURIComponent(`${arrivalDate} ${arrivalTime}`) +
              "&departure=" +
              encodeURIComponent(`${departureDate} ${departureTime}`) +
              "&promotionCode=" +
              encodeURIComponent(voucher) +
              "&affiliateCode=" +
              encodeURIComponent(affiliateCode) +
              sorting,
          )
          .then((res) => res.data)
          .then((searchResult) => {
            const result = searchResult.productCategories
            const parkingList = config.get("textKeys.parkingList")
            var allProducts = []
            if (result && result.length > 0) {
              result.forEach((element) => {
                allProducts = [...allProducts, ...element.products]
              })
            }
            if (parkingList.sorting && parkingList.sorting && parkingList.sorting.options[0]) {
              allProducts = sort(parkingList.sorting.options[0].sortingKey, allProducts)
            }
            if (allProducts.length > 0) trackSoldOutRate(allProducts)
            setGlobalState({
              // changeFromBooking: changeFromBookingResult,
              isLoaded: true,
              globals: searchResult.searchResultGlobals,
              productCategories: result,
              allProducts,
              arrivalDate,
              arrivalTime,
              departureDate,
              departureTime,
              voucher,
              durationDays: Math.ceil(Math.abs(new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) / (1000 * 60 * 60 * 24)),
              flightInformation: {
                outboundFlightDate: arrivalDate,
                inboundFlightDate: departureDate,
              },
              ajaxSpinnerActive: false,
              loadingPerformChangeBookingSearch: false,
              // changeFromBookingGuid: changeFromBookingGuid
            })

            if (changeFromBookingResult) {
              const sortedProducts = amendmentSorting(allProducts, changeFromBookingResult, true)
              setGlobalState({ allProducts: sortedProducts })
            } else {
              const sortedProducts = spacesSorting(allProducts)
              setGlobalState({ allProducts: sortedProducts })
            }

            const query = {
              ad: arrivalDate,
              at: arrivalTime,
              dd: departureDate,
              dt: departureTime,
              voucher,
              affiliate: affiliateCode,
              cfguid: changeFromBookingGuid,
              email,
              reference,
            }
            if (replaceHistory) {
              history.replace({
                pathname: path.SEARCH_AMMEND_BOOKING(),
                search: createQueryStrings(query),
              })
            } else {
              history.push({
                pathname: path.SEARCH_AMMEND_BOOKING(),
                search: createQueryStrings(query),
              })
            }
            parkingState.setState({ bookingResult: undefined, bookingExtras: undefined })
          })
          .catch((error) => {
            const text = axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingPerformChangeBookingSearch: false,
              loadingPerformChangeBookingSearchError: error,
            })
            if (text) trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, "search")
          })
      },
    )
  }
}

export const performChangeBookingTime = (
  changeFromBookingResult,
  arrivalDate,
  arrivalTime,
  departureDate,
  departureTime,
  voucher = "",
  affiliateCode = "",
  reference,
  email,
  replaceHistory,
  sorting = "",
  history,
) => {
  if (!parkingState.getState().loadingPerformChangeBookingSearch) {
    const changeFromBookingGuid = changeFromBookingResult.booking.guid
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingPerformChangeBookingSearch: true,
        loadingPerformChangeBookingSearchError: undefined,
      },
      () => {
        console.debug("performChangeBookingSearch")
        axios
          .get(
            endpoint.FIND_PARKING_CHANGE_TIMEONLY(changeFromBookingGuid) +
              "?arrival=" +
              encodeURIComponent(`${arrivalDate} ${arrivalTime}`) +
              "&departure=" +
              encodeURIComponent(`${departureDate} ${departureTime}`) +
              "&promotionCode=" +
              encodeURIComponent(voucher) +
              "&affiliateCode=" +
              encodeURIComponent(affiliateCode) +
              sorting,
          )
          .then((res) => res.data)
          .then((searchResult) => {
            const result = searchResult.productCategories
            var allProducts = []
            if (result && result.length > 0)
              result.forEach((element) => {
                allProducts = [...allProducts, ...element.products]
              })
            if (allProducts.length > 0) trackSoldOutRate(allProducts)

            const sortedProducts = spacesSorting(allProducts)

            setGlobalState({
              // changeFromBooking: changeFromBookingResult,
              isLoaded: true,
              globals: searchResult.searchResultGlobals,
              productCategories: result,
              allProducts: sortedProducts,
              arrivalDate,
              arrivalTime,
              departureDate,
              departureTime,
              voucher,
              durationDays: Math.ceil(Math.abs(new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) / (1000 * 60 * 60 * 24)),
              flightInformation: {
                outboundFlightDate: arrivalDate,
                inboundFlightDate: departureDate,
              },
              ajaxSpinnerActive: false,
              loadingPerformChangeBookingSearch: false,
              // changeFromBookingGuid: changeFromBookingGuid
            })

            const query = {
              ad: arrivalDate,
              at: arrivalTime,
              dd: departureDate,
              dt: departureTime,
              voucher,
              affiliate: affiliateCode,
              cfguid: changeFromBookingGuid,
              email,
              reference,
            }
            if (replaceHistory) {
              history.replace({
                pathname: path.AMMEND_EDIT_TIME(),
                search: createQueryStrings(query),
              })
            } else {
              history.push({
                pathname: path.AMMEND_EDIT_TIME(),
                search: createQueryStrings(query),
              })
            }
            parkingState.setState({ bookingResult: undefined, bookingExtras: undefined })
          })
          .catch((error) => {
            const text = axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingPerformChangeBookingSearch: false,
              loadingPerformChangeBookingSearchError: error,
            })
            if (text) trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, "search")
          })
      },
    )
  }
}
export const performChangeBookingExitTime = (changeFromBookingGuid, departureDate, departureTime, reference, email, replaceHistory, history) => {
  if (parkingState.getState().bookingExtension) {
    const { departureDate: cfDepartureDate, departureTime: cfDepartureTime } = parkingState.getState().bookingExtension.booking
    if (departureDate === cfDepartureDate && departureTime === cfDepartureTime) {
      const query = {
        dd: departureDate,
        dt: departureTime,
        cfguid: changeFromBookingGuid,
        email: email,
        reference: reference,
      }
      if (replaceHistory) {
        history.replace({
          pathname: path.AMMEND_EXTEND_TIME(),
          search: createQueryStrings(query),
        })
      } else {
        history.push({
          pathname: path.AMMEND_EXTEND_TIME(),
          search: createQueryStrings(query),
        })
      }
      setGlobalState({
        bookingExtension: undefined,
      })
      return
    }
  }

  if (parkingState.getState().manageBookingResult) {
    if (
      departureDate !== parkingState.getState().manageBookingResult.booking.departureDate ||
      departureTime !== parkingState.getState().manageBookingResult.booking.departureTime
    ) {
      if (!parkingState.getState().loadingPerformChangeBookingSearch) {
        setGlobalState(
          {
            ajaxSpinnerActive: true,
            loadingPerformChangeBookingExitTime: true,
            loadingPerformChangeBookingExitTimeError: undefined,
          },
          () => {
            console.debug("performChangeBookingExitTime")
            axios
              .get(
                endpoint.FIND_BOOKING_EXTENSION_BY_GUID(changeFromBookingGuid) +
                  "?newDeparture=" +
                  encodeURIComponent(`${departureDate}T${departureTime}`),
              )
              .then((res) => {
                const query = {
                  dd: departureDate,
                  dt: departureTime,
                  cfguid: changeFromBookingGuid,
                  email: email,
                  reference: reference,
                  extensionId: res.data?.parkingExtension?.extensionId,
                }
                if (replaceHistory) {
                  history.replace({
                    pathname: path.AMMEND_EXTEND_TIME(),
                    search: createQueryStrings(query),
                  })
                } else {
                  history.push({
                    pathname: path.AMMEND_EXTEND_TIME(),
                    search: createQueryStrings(query),
                  })
                }
                setGlobalState({
                  bookingExtension: res.data,
                  isLoaded: true,
                  ajaxSpinnerActive: false,
                  loadingPerformChangeBookingExitTime: false,
                })
              })
              .catch((error) => {
                const text = axiosErrorHandler(error, {
                  ajaxSpinnerActive: false,
                  loadingPerformChangeBookingExitTime: false,
                  loadingPerformChangeBookingExitTimeError: error,
                })
                if (text) trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, "search")
              })
          },
        )
      }
    }
  }
}
export const performParkingSearch = (
  arrivalDate,
  arrivalTime,
  departureDate,
  departureTime,
  voucher,
  affiliateCode,
  replaceHistory,
  errorType = "search",
  sorting = "",
  history,
) => {
  const textKeys = config.get("textKeys.dialog") || {}
  let terminalProximityPriority = ""
  let cheapestFacilityPriority = ""
  let bestOfferFacilityPriority = ""

  const arrival = `${arrivalDate} ${arrivalTime}`
  const departure = `${departureDate} ${departureTime}`
  const arrivalDateTime = DateTime.fromFormat(arrival, "yyyy-MM-dd HH:mm")
  const departureDateTime = DateTime.fromFormat(departure, "yyyy-MM-dd HH:mm")

  const duration = departureDateTime.diff(arrivalDateTime, ["days"]).toObject()
  const days = Math.floor(duration.days)

  const isLoggedIn = cookieHelper.isLoggedIn()
  const isShortDuration = days < 3
  const content = config.get("content")

  // terminal proximity priority
  if (content?.terminalProximityPriorityShortDuration && isShortDuration)
    if (content?.terminalProximityPriorityShortDurationAffiliate && affiliateCode)
      terminalProximityPriority = content?.terminalProximityPriorityShortDurationAffiliate
    else if (content?.terminalProximityPriorityShortDurationLoggedIn && isLoggedIn)
      terminalProximityPriority = content?.terminalProximityPriorityShortDurationLoggedIn
    else terminalProximityPriority = content?.terminalProximityPriorityShortDuration
  else if (content?.terminalProximityPriority)
    if (content?.terminalProximityPriorityAffiliate && affiliateCode) terminalProximityPriority = content?.terminalProximityPriorityAffiliate
    else terminalProximityPriority = content?.terminalProximityPriority

  // cheapest facility priority
  if (content?.cheapestFacilityPriorityShortDuration && isShortDuration)
    if (content?.cheapestFacilityPriorityShortDurationAffiliate && affiliateCode)
      cheapestFacilityPriority = content?.cheapestFacilityPriorityShortDurationAffiliate
    else if (content?.cheapestFacilityPriorityShortDurationLoggedIn && isLoggedIn)
      cheapestFacilityPriority = content?.cheapestFacilityPriorityShortDurationLoggedIn
    else cheapestFacilityPriority = content?.cheapestFacilityPriorityShortDuration
  else if (content?.cheapestFacilityPriority)
    if (content?.cheapestFacilityPriorityAffiliate && affiliateCode) cheapestFacilityPriority = content?.cheapestFacilityPriorityAffiliate
    else cheapestFacilityPriority = content?.cheapestFacilityPriority

  // best offer priority
  if (content?.bestOfferFacilityPriorityShortDuration && isShortDuration)
    if (content?.bestOfferFacilityPriorityShortDurationAffiliate && affiliateCode)
      bestOfferFacilityPriority = content?.bestOfferFacilityPriorityShortDurationAffiliate
    else if (content?.bestOfferFacilityPriorityShortDurationLoggedIn && isLoggedIn)
      bestOfferFacilityPriority = content?.bestOfferFacilityPriorityShortDurationLoggedIn
    else bestOfferFacilityPriority = content?.bestOfferFacilityPriorityShortDuration
  else if (content?.bestOfferFacilityPriority)
    if (content?.bestOfferFacilityPriorityAffiliate && affiliateCode) bestOfferFacilityPriority = content?.bestOfferFacilityPriorityAffiliate
    else bestOfferFacilityPriority = content?.bestOfferFacilityPriority

  if (!parkingState.getState().loadingPerformParkingSearch) {
    parkingState.setState({
      ajaxSpinnerActive: true,
      loadingPerformParkingSearch: true,
      loadingPerformParkingSearchError: undefined,
    })

    const url =
      endpoint.FIND_PARKING() +
      "?arrival=" +
      encodeURIComponent(arrival) +
      "&departure=" +
      encodeURIComponent(departure) +
      "&promotionCode=" +
      (voucher ? encodeURIComponent(voucher) : "") +
      "&affiliateCode=" +
      (affiliateCode ? encodeURIComponent(affiliateCode) : "") +
      "&terminalProximityPriority=" +
      encodeURIComponent(terminalProximityPriority) +
      "&cheapestFacilityPriority=" +
      encodeURIComponent(cheapestFacilityPriority) +
      "&bestOfferFacilityPriority=" +
      encodeURIComponent(bestOfferFacilityPriority) +
      sorting
    console.debug("calledbookingsearch: " + url)
    axios
      .get(url)
      .then((res) => res.data)
      .then((searchResult) => {
        const result = searchResult.productCategories
        var allProducts = []
        if (result && result.length > 0) {
          result.forEach((element) => {
            allProducts = [...allProducts, ...element.products]
          })
        }

        const parkingList = config.get("textKeys.parkingList")
        if (parkingList.sorting && parkingList.sorting && parkingList.sorting.options[1] && !parkingState.getState().voucher) {
          if (parkingList.sorting.options.length >= 1) allProducts = sort(parkingList.sorting.options[1].sortingKey, allProducts)
        }
        if (allProducts.length > 0) {
          trackSoldOutRate(allProducts)

          // check if all products are sold out
          const amountOfProducts = allProducts.length
          let amountOfSoldOutProducts = 0
          allProducts.forEach((item) => {
            if (item.product.isSoldOut) {
              amountOfSoldOutProducts++
            }
          })
          let notificationBanner = document.getElementsByClassName("notifications soldOutBanner")[0]
          if (notificationBanner) {
            if (amountOfProducts === amountOfSoldOutProducts) {
              notificationBanner.classList.remove("hide")
            } else {
              notificationBanner.classList.add("hide")
            }
            new Sticky({ el: document.querySelector(".parking-time-picker-wrapper") })
          }
        }

        if (voucher && !searchResult.searchResultGlobals.promotionName) {
          parkingState.setState({
            voucher: undefined,
            ajaxSpinnerActive: false,
            loadingPerformParkingSearch: false,
          })
          genericModalOpen(
            (config.get("textKeys.dialog.voucherNotFound") &&
              config.get("textKeys.dialog.voucherNotFound").replace("${", "{").replace("{voucher}", voucher)) ||
              `<h3>Ukendt kampagnekode</h3><p>Den indtastede kampagnekode <strong>${voucher}</strong> kan ikke findes i systemet</p>`,
          )

          return
        }
        parkingState.setState({
          isLoaded: true,
          globals: searchResult.searchResultGlobals,
          productCategories: result,
          allProducts,
          arrivalDate,
          arrivalTime,
          departureDate,
          departureTime,
          voucher,
          durationDays: Math.ceil(Math.abs(new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) / (1000 * 60 * 60 * 24)),
          flightInformation: {
            outboundFlightDate: arrivalDate,
            inboundFlightDate: departureDate,
          },
          ajaxSpinnerActive: false,
          loadingPerformParkingSearch: false,
          parkingHighlights: searchResult.productHighlights,
        })
      })
      .catch((error) => {
        const text = axiosErrorHandler(
          error,
          {
            ajaxSpinnerActive: false,
            loadingPerformParkingSearch: false,
            loadingPerformParkingSearchError: error,
          },
          {
            badRequest: () => {
              genericModalOpen(
                textKeys.noBookingInThePast || `<h3>Tidsfristen er overskredet</h3><p>Du kan tidligst booke 1 timer før ønsket ankomsttidspunkt</p>`,
              )
            },
          },
        )
        if (text) trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, errorType)
      })
      .finally(() => {
        const query = {
          ad: arrivalDate,
          at: arrivalTime,
          dd: departureDate,
          dt: departureTime,
        }
        if (voucher) query.voucher = voucher
        if (affiliateCode) query.affiliate = affiliateCode
        if (parkingState.getState().changeFromBookingGuid) query.cfguid = parkingState.getState().changeFromBookingGuid
        if (parkingState.getState().ammendmentEmail) query.email = parkingState.getState().ammendmentEmail
        if (parkingState.getState().ammendmentReference) query.reference = parkingState.getState().ammendmentReference
        if (replaceHistory) {
          history.replace({
            pathname: path.SEARCH(),
            search: createQueryStrings(query),
          })
        } else {
          history.push({
            pathname: path.SEARCH(),
            search: createQueryStrings(query),
          })
        }
        parkingState.setState({ bookingResult: undefined, bookingExtras: undefined })
      })
  }
}

export const findBooking = (email, reference, history) => {
  if (!parkingState.getState().loadingFindBooking) {
    parkingState.setState({
      ajaxSpinnerActive: true,
      loadingFindBooking: true,
      findBookingError: undefined,
    })

    axios
      .get(endpoint.FIND_BOOKING() + "?email=" + encodeURIComponent(email) + "&bookingReference=" + encodeURIComponent(reference))
      .then((res) => res.data)
      .then((result) => {
        let queryStringDiffersFromAmendedBooking = false
        const { arrivalDate, arrivalTime, departureDate, departureTime } = parkingState.getState()
        if (arrivalDate !== result.booking.arrivalDate) queryStringDiffersFromAmendedBooking = true
        if (arrivalTime !== result.booking.arrivalTime) queryStringDiffersFromAmendedBooking = true
        if (departureDate !== result.booking.departureDate) queryStringDiffersFromAmendedBooking = true
        if (departureTime !== result.booking.departureTime) queryStringDiffersFromAmendedBooking = true

        const newState = {
          isLoaded: true,
          manageBookingResult: result,
          ajaxSpinnerActive: false,
          loadingFindBooking: false,
          changeFromBookingGuid: result.booking.guid,
          queryStringDiffersFromAmendedBooking: queryStringDiffersFromAmendedBooking,
        }

        if (!parkingState.getState().hasQueryParameters) {
          newState.arrivalDate = result.booking.arrivalDate
          newState.arrivalTime = result.booking.arrivalTime
          newState.departureDate = result.booking.departureDate
          newState.departureTime = result.booking.departureTime
          newState.voucher = result.booking.promotionCode
          newState.affiliateCode = result.booking.affiliateCode
        }

        apiHelper.findUpsaleForBooking(result.booking.guid)
        parkingState.setState(newState)
        return true
      })
      .catch((error) => {
        history.replace({
          pathname: path.AMMEND_SEARCH(),
          search: window.location.search,
        })
        genericModalOpen(
          config.get("textKeys.dialog.searchError") ||
            "<h3>Fejl ved opslag på email og reference</h3><p>Vi kan ikke finde den angivne kombination af email og bookingnummer i systemet, kontroller at du har skrevet begge værdier korrekt</p><p>Prøv igen</p>",
        )
        parkingState.setState({
          isLoaded: true,
          ajaxSpinnerActive: false,
          findBookingError: error,
          loadingFindBooking: false,
        })
      })
  }
}

export const getBookingByGuid = (bookingGuid, callback) => {
  if (!parkingState.getState().loadGetBookingByGuid) {
    setGlobalState(
      {
        loadGetBookingByGuid: true,
        loadGetBookingByGuidError: undefined,
      },
      () => {
        axios
          .get(endpoint.FIND_BOOKING_BY_GUID(bookingGuid))
          .then((res) => res.data)
          .then((result) => {
            setGlobalState(
              {
                loadGetBookingByGuid: false,
                manageBookingResult: result,
              },
              () => callback(),
            )

            return true // tell caller that this was a success
          })
          .catch((error) => {
            axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadGetBookingByGuid: false,
              loadGetBookingByGuidError: error,
            })
          })
      },
    )
  }
}

export const cancelBooking = (bookingGuid, callback) => {
  if (!parkingState.getState().loadCancelBooking) {
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadCancelBooking: true,
        loadCancelBookingError: undefined,
      },
      () => {
        axios
          .post(endpoint.CANCELLATION(bookingGuid))
          .then(() => {
            getBookingByGuid(bookingGuid, () => {
              parkingState.setState({
                isLoaded: true,
                ajaxSpinnerActive: false,
                loadCancelBooking: false,
              })
            })
            return true // tell caller that this was a success
          })
          .then(() => callback())
          .catch((error) => {
            axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadCancelBooking: false,
              loadCancelBookingError: error,
            })
          })
      },
    )
  }
}
export const modifyBookingInformation = (information, callback = null) => {
  if (!parkingState.getState().loadingModifyBookingInformation) {
    const { booking } = parkingState.getState().manageBookingResult
    parkingState.setState({
      ajaxSpinnerActive: true,
      loadingModifyBookingInformation: true,
      loadingModifyBookingInformationError: undefined,
    })

    const data = {
      arrivalDate: `${booking.arrivalDate} ${booking.arrivalTime}`,
      departureDate: `${booking.departureDate} ${booking.departureTime}`,
      ...information,
    }
    axios
      .post(endpoint.MODIFY_BOOKING_INFORMATION(parkingState.getState().manageBookingResult.booking.guid), data)
      .then((res) => res.data)
      .then((result) => {
        parkingState.setState({
          isLoaded: true,
          manageBookingResult: result,
          ajaxSpinnerActive: false,
          loadingModifyBookingInformation: false,
        })
        if (callback) {
          callback()
        }
        return true // tell caller that this was a success
      })
      .catch((error) => {
        axiosErrorHandler(error, {
          ajaxSpinnerActive: false,
          loadingModifyBookingInformation: false,
          loadingModifyBookingInformationError: error,
        })
      })
  }
}

export const handleEmailOfferUpgrade = (bookingGuid, history) => {
  if (!parkingState.getState().emailUpgradeInProcess) {
    setGlobalState(
      {
        emailUpgradeInProcess: true,
        emailUpgradeGuid: bookingGuid,
        loadingHandleEmailOfferUpgradeError: undefined,
        genericModalBody: config.get("textKeys.dialog.upgrade"),
      },
      () => {
        storageHelper.setToSessionStorage("emailUpgradeGuid", bookingGuid)
        axios
          .get(endpoint.EMAIL_UPGRADE_BOOKING(bookingGuid))
          .then((res) => res.data)
          .then((result) => {
            if (!result.error) {
              setGlobalState(
                {
                  emailUpgradeInProcess: false,
                  loadingHandleEmailOfferUpgrade: false,
                },
                () => {
                  history.push({
                    pathname: path.CHECKOUT(),
                    search: createQueryStrings(result),
                  })
                },
              )
            } else {
              console.log(result.error)
            }
          })
          .catch((error) => {
            axiosErrorHandler(
              error,
              {
                // ajaxSpinnerActive: false,
                emailUpgradeInProcess: false,
                loadingHandleEmailOfferUpgradeError: error,
              },
              {
                noResponse: () =>
                  genericModalOpen(
                    config.get("textKeys.dialog.linkError") ||
                      `<h3>Fejl</h3><p>Der er en fejl i linket, hvis du har klippe klistret det ind så prøv igen</p>`,
                  ),
                methodNotAllowed: () =>
                  genericModalOpen(
                    config.get("textKeys.dialog.upgradeError") ||
                      `<h3>Fejl</h3><p>Din booking kan ikke opgraderes, enten er tidsfristen udløbet, ellers også er der udsolgt</p>`,
                  ),
              },
            )
          })
      },
    )
  }
}

export const handleReservation = (id, item, callback, history) => {
  let hasChangeFromBooking = parkingState.getState().changeFromBooking ? true : false
  let hasLoggedInAccountDetails = parkingState.getState().userAccountDetails ? true : false
  let hasChangeFromBookingLoggedInHistory = false
  let hasAccountDetails = false
  let hasAccountHistory = false
  if (hasChangeFromBooking) {
    hasChangeFromBookingLoggedInHistory = parkingState.getState().changeFromBooking.booking.membershipNumber ? true : false
  }
  if (hasLoggedInAccountDetails) {
    hasAccountHistory = parkingState.getState().userAccountDetails.CustomerNumber ? true : false
  }
  let useMemberPricing =
    !item?.result?.showOriginalPrice &&
    item?.result?.showMemberPrice &&
    (hasAccountDetails || hasAccountHistory || hasChangeFromBookingLoggedInHistory)
      ? true
      : false

  if (!parkingState.getState().loadingHandleReservation) {
    if (parkingState.getState().changeFromBookingGuid) {
      console.debug("handleReservation:" + endpoint.CHANGE_UPGRADE_BOOKING(parkingState.getState().changeFromBookingGuid) + ", id=" + id)
      const data = {
        arrivalDate: parkingState.getState().arrivalDate,
        arrivalTime: parkingState.getState().arrivalTime,
        departureDate: parkingState.getState().departureDate,
        departureTime: parkingState.getState().departureTime,
        productId: id,
        promotionCode: parkingState.getState().changeFromBooking?.booking?.promotionCode || "",
        affiliateCode: parkingState.getState().affiliateCode,
        membershipId: hasAccountHistory
          ? parkingState.getState().changeFromBooking?.booking?.memberShipNumber
          : hasAccountDetails
            ? parkingState.getState().userAccountDetails?.CustomerNumber
            : "",
        useMemberPricing: useMemberPricing,
        validatePromoCodeWithAmendmentDates: !parkingState.getState().changeFromBooking?.booking?.promotionCode, // validate if promoCode comes from somewhere other than your previous booking
        thirdPartyPromoLabel: item?.result?.thirdPartyPromoLabel || "",
      }
      //membership id / pricing is checked first on the changed booking. If the previous booking wasnt logged in, then we check if you're actually logged in.
      setGlobalState(
        {
          ajaxSpinnerActive: true,
          loadingHandleReservation: true,
          loadingHandleReservationError: undefined,
        },
        () => {
          axios
            .put(endpoint.CHANGE_UPGRADE_BOOKING(parkingState.getState().changeFromBookingGuid), data)
            .then((result) => result.data)
            .then((result) => {
              if (result.message) {
                console.debug(result.message)
              }

              if (result.booking) {
                saveGuidToSessionStorage(result)
                findExtrasForBooking(
                  id,
                  getArrivalData(),
                  getDepartureData(),
                  result.booking.guid,
                  parkingState.getState().voucher,
                  true,
                  "",
                  history,
                )
                setGlobalState(
                  {
                    bookingUpsale: undefined,
                    bookingResult: result,
                    loadingHandleReservation: false,
                  },
                  () => {
                    const query = {
                      ad: parkingState.getState().arrivalDate,
                      at: parkingState.getState().arrivalTime,
                      dd: parkingState.getState().departureDate,
                      dt: parkingState.getState().departureTime,
                      voucher: parkingState.getState().voucher,
                      affiliate: parkingState.getState().affiliateCode,
                      bguid: parkingState.getState().bookingResult.booking.guid,
                      cfguid: parkingState.getState().changeFromBookingGuid,
                      parkingProductId: id,
                      promotionCode: parkingState.getState().bookingResult.booking.bookingHistory.originalBooking.promotionCode,
                    }
                    if (parkingState.getState().ammendmentEmail) query.email = parkingState.getState().ammendmentEmail
                    if (parkingState.getState().ammendmentReference) query.reference = parkingState.getState().ammendmentReference

                    if (result.activeBookingExtraProducts && result.activeBookingExtraProducts.find((product) => product.showBookingPage === false)) {
                      // booking already has carwash go directly to financial page
                      history.push({
                        pathname: path.CHECKOUT(),
                        search: createQueryStrings(query),
                      })
                    } else {
                      // JIRA: https://cph-airport.atlassian.net/browse/PAR-288
                      // Advam fails on Carwash change on booking amandment, so disabled until further notice
                      if (
                        parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOWCHANGECARPARK ||
                        parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOWEDITTIME ||
                        parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOW ||
                        parkingState.getState().currentFlow === FlowEnum.AMENDMENTSEARCH
                      ) {
                        history.push({
                          pathname: path.AMMEND_CHECKOUT(),
                          search: createQueryStrings(query),
                        })
                      } else if (
                        parkingState.getState().currentFlow !== FlowEnum.AMENDMENTFLOWCHANGECARPARK ||
                        parkingState.getState().currentFlow !== FlowEnum.AMENDMENTFLOWEDITTIME ||
                        parkingState.getState().currentFlow !== FlowEnum.AMENDMENTFLOW ||
                        parkingState.getState().currentFlow !== FlowEnum.AMENDMENTSEARCH
                      ) {
                        history.push({
                          pathname: path.CHECKOUT(),
                          search: createQueryStrings(query),
                        })
                      }
                    }
                    if (callback) {
                      callback()
                      // console.log('calling back ' + callback);
                    }
                  },
                )
              }
            })
            .catch((error) => {
              axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingHandleReservation: false,
                loadingHandleReservationError: error,
              })
            })
        },
      )
    } else {
      console.debug("handleReservation:" + endpoint.ADD_RESERVATION() + ", id=" + id)
      handleReservationInternal(id, item, callback, history)
    }
  }
}

export const handleReservationInternal = (productId, item, callback, history) => {
  const data = {
    arrivalDate: getArrivalData(),
    departureDate: getDepartureData(),
    productId: productId,
    promotionCode: parkingState.getState().voucher,
    affiliateCode: parkingState.getState().affiliateCode,
    usePromoCodePrice: item?.result?.showOriginalPrice || false,
    thirdPartyPromoLabel: item?.result?.thirdPartyPromoLabel || "",
    result: item?.result || null,
  }
  setGlobalState(
    {
      ajaxSpinnerActive: true,
      loadingHandleReservation: true,
      loadingHandleReservationError: undefined,
    },
    () => {
      axios
        .post(endpoint.ADD_RESERVATION(), data)
        .then((result) => result.data)
        .then((result) => {
          if (result.message) {
            console.debug(result.message)
          }
          if (result.booking) {
            saveGuidToSessionStorage(result)
            // PAR-2070 - moved history handling to findExtras function, to make the skipping of step 2 more smooth
            const query = {
              ad: parkingState.getState().arrivalDate,
              at: parkingState.getState().arrivalTime,
              dd: parkingState.getState().departureDate,
              dt: parkingState.getState().departureTime,
              voucher: parkingState.getState().voucher,
              affiliate: parkingState.getState().affiliateCode,
              bguid: result.booking.guid,
              cfguid: parkingState.getState().changeFromBookingGuid,
              parkingProductId: productId,
            }
            findExtrasForBooking(
              productId,
              getArrivalData(),
              getDepartureData(),
              result.booking.guid,
              parkingState.getState().voucher,
              true,
              createQueryStrings(query),
              history,
            )
            findUpsaleForBooking(result.booking.guid)
            parkingState.setState({
              bookingUpsale: undefined,
              bookingResult: result,
              ajaxSpinnerActive: false,
              loadingHandleReservation: false,
            })
          }
          if (callback) {
            callback()
          }
        })
        .catch((error) => {
          axiosErrorHandler(error, {
            ajaxSpinnerActive: false,
            loadingHandleReservation: false,
            loadingHandleReservationError: error,
          })
        })
    },
  )
}

export const handleBookingExtension = (newDeparture, callback, history) => {
  let hasChangeFromBooking = parkingState.getState().changeFromBooking ? true : false
  let hasLoggedInAccountDetails = parkingState.getState().userAccountDetails ? true : false
  let hasChangeFromBookingLoggedInHistory = false
  // let hasAccountDetails = false //hasAccoutnDetails is never used. if anyone knows a use for it, use it, otherwise delete.
  let hasAccountHistory = false

  if (hasChangeFromBooking) {
    hasChangeFromBookingLoggedInHistory = parkingState.getState().changeFromBooking.booking.membershipNumber
  }

  if (hasLoggedInAccountDetails) {
    hasAccountHistory = parkingState.getState().userAccountDetails.CustomerNumber ? true : false
  }

  if (!parkingState.getState().loadingHandleReservation) {
    if (parkingState.getState().changeFromBookingGuid) {
      console.debug(
        "handleBookingExtension:" +
          endpoint.EXECUTE_BOOKING_EXTENSION_BY_GUID(parkingState.getState().bookingExtension.booking.guid) +
          "?newDeparture=" +
          newDeparture,
      )
      const data = {
        newDeparture: newDeparture,
      }
      //membership id / pricing is checked first on the changed booking. If the previous booking wasnt logged in, then we check if you're actually logged in.
      setGlobalState(
        {
          ajaxSpinnerActive: true,
          loadingHandleReservation: true,
          loadingHandleReservationError: undefined,
        },
        () => {
          axios
            .get(
              endpoint.EXECUTE_BOOKING_EXTENSION_BY_GUID(parkingState.getState().bookingExtension.booking.guid) +
                "?newDeparture=" +
                data.newDeparture,
            )
            .then((result) => result.data)
            .then((result) => {
              if (result.message) {
                console.debug(result.message)
              }

              if (result.booking) {
                saveGuidToSessionStorage(result)
                setGlobalState(
                  {
                    bookingUpsale: undefined,
                    bookingExtension: result,
                    loadingHandleReservation: false,
                    ajaxSpinnerActive: false,
                  },
                  () => {
                    const query = {
                      dd: parkingState.getState().departureDate,
                      dt: parkingState.getState().departureTime,
                      bguid: parkingState.getState().bookingExtension.booking.guid,
                      cfguid: parkingState.getState().changeFromBookingGuid,
                      extensionId: parkingState.getState().bookingExtension?.parkingExtension?.extensionId,
                    }
                    if (parkingState.getState().ammendmentEmail) query.email = parkingState.getState().bookingExtension.booking.email
                    if (parkingState.getState().ammendmentReference) query.reference = parkingState.getState().bookingExtension.booking.reference

                    // JIRA: https://cph-airport.atlassian.net/browse/PAR-288
                    // Advam fails on Carwash change on booking amandment, so disabled until further notice
                    if (parkingState.getState().bookingExtension) {
                      history.push({
                        pathname: path.EXTEND_CHECKOUT(),
                        search: createQueryStrings(query),
                      })
                    }

                    //  this.props.history.push({
                    //   pathname: path.EXTRA_SERVICES(),
                    //   search: createQueryStrings(query)
                    // })
                    if (callback) {
                      callback()
                      // console.log('calling back ' + callback);
                    }
                  },
                )
              }
            })
            .catch((error) => {
              axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingHandleReservation: false,
                loadingHandleReservationError: error,
              })
            })
        },
      )
    } else {
      handleReservationInternal(callback)
    }
  }
}

export const findUpsaleForBooking = (bookingGuid) => {
  let allowedUpsaleCarparks = ""
  if (config.get("content")?.allowedUpsaleCarparks) allowedUpsaleCarparks = config.get("content")?.allowedUpsaleCarparks
  if (!parkingState.getState().loadingFindUpsaleForBooking) {
    parkingState.setState({
      ajaxSpinnerActive: true,
      loadingFindUpsaleForBooking: true,
      loadingFindUpsaleForBookingError: undefined,
    })

    axios
      .get(endpoint.FIND_BOOKING_UPSALE_BY_GUID(bookingGuid) + "?allowedUpsaleCarparks=" + encodeURIComponent(allowedUpsaleCarparks))
      .then((res) => res.data)
      .then((result) => {
        parkingState.setState({
          bookingUpsale: result,
          ajaxSpinnerActive: false,
          loadingFindUpsaleForBooking: false,
        })
        return true // tell caller that this was a success
      })
      .catch((error) => {
        const text = axiosErrorHandler(error, {
          bookingUpsale: undefined,
          ajaxSpinnerActive: false,
          loadingFindUpsaleForBooking: false,
          loadingFindUpsaleForBookingError: error,
        })
        if (text) trackError(text, error, "upsale")
      })
  }
}

export const executeUpsaleForBooking = (bookingGuid, upsaleProductId, previousProductName, history) => {
  if (!parkingState.getState().loadingExecuteUpsaleForBooking) {
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingExecuteUpsaleForBooking: true,
        loadingExecuteUpsaleForBookingError: undefined,
      },
      () => {
        if (parkingState.getState().currentFlow !== FlowEnum.AMENDMENTFLOW && parkingState.getState().currentFlow !== FlowEnum.AMENDMENTSEARCH) {
          axios
            .post(
              endpoint.EXECUTE_BOOKING_UPSALE_BY_GUID(bookingGuid) +
                "?upsaleProductId=" +
                encodeURIComponent(upsaleProductId) +
                "&previousProductName=" +
                encodeURIComponent(previousProductName),
            )
            .then((res) => res.data)
            .then((result) => {
              if (result.booking) {
                setGlobalState(
                  {
                    bookingResult: result,
                    ajaxSpinnerActive: false,
                    loadingAddExtraToBooking: false,
                    isUpsold: true,
                  },
                  () => {
                    const query = {
                      ad: parkingState.getState().arrivalDate,
                      at: parkingState.getState().arrivalTime,
                      dd: parkingState.getState().departureDate,
                      dt: parkingState.getState().departureTime,
                      voucher: parkingState.getState().voucher,
                      affiliate: parkingState.getState().affiliateCode,
                      bguid: parkingState.getState().bookingResult.booking.guid,
                      cfguid: parkingState.getState().changeFromBookingGuid,
                      parkingProductId: upsaleProductId,
                      isUpsold: true,
                    }
                    if (parkingState.getState().ammendmentEmail) query.email = parkingState.getState().ammendmentEmail
                    if (parkingState.getState().ammendmentReference) query.reference = parkingState.getState().ammendmentReference

                    //set cookie with old product id and name, upsale product id and name
                    if (parkingState.getState().upsaleTrackingData) {
                      cookieHelper.setCookie("upsaleTrackingData", parkingState.getState().upsaleTrackingData)
                    }

                    // JIRA: https://cph-airport.atlassian.net/browse/PAR-288
                    // Advam fails on Carwah change on booking amandment, so disabled until further notice
                    if (
                      parkingState.getState().currentFlow !== FlowEnum.AMENDMENTFLOW &&
                      parkingState.getState().currentFlow !== FlowEnum.AMENDMENTSEARCH
                    ) {
                      history.replace({
                        pathname: path.CHECKOUT(),
                        search: createQueryStrings(query),
                      })
                    }
                  },
                )
              }
              return true // tell caller that this was a success
            })
            .catch((error) => {
              const text = axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingExecuteUpsaleForBooking: false,
                loadingExecuteUpsaleForBookingError: error,
              })
              if (text) trackError(text, error, "upsale")
            })
        } else if (
          parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOW ||
          parkingState.getState().currentFlow === FlowEnum.AMENDMENTSEARCH
        ) {
          //set cookie with old product id and name, upsale product id and name
          if (parkingState.getState().upsaleTrackingData) {
            cookieHelper.setCookie("upsaleTrackingData", parkingState.getState().upsaleTrackingData)
          }
          handleReservation(parkingState.getState().bookingUpsale.result.product, "", null, history)
        }
      },
    )
  }
}

export const findExtrasForBooking = (productId, arrival, departure, bookingGuid, voucher, handleHistory = false, query = "", history) => {
  if (!parkingState.getState().loadingFindExtrasForBooking) {
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingFindExtrasForBooking: true,
        loadingFindExtrasForBookingError: undefined,
      },
      () => {
        axios
          .get(
            endpoint.FIND_EXTRAS_WITH_CONFIG(bookingGuid) +
              "?productId=" +
              encodeURIComponent(productId) +
              "&arrival=" +
              encodeURIComponent(arrival) +
              "&departure=" +
              encodeURIComponent(departure) +
              "&promotionCode=" +
              encodeURIComponent(voucher),
          )
          .then((res) => res.data)
          .then((result) => {
            if (handleHistory === true && query !== "") {
              const textKeys = config.get("textKeys")
              let showStep2 = textKeys.extraServices.showExtraServicesStep
              if (showStep2) {
                // if showStep2, enforce another rule
                const extras = result.extras
                showStep2 = extras.length > 0 || extras.filter((be) => !be.showBookingPage).length > 0
              }
              history.push({
                pathname: showStep2 ? path.EXTRA_SERVICES() : path.CHECKOUT(),
                search: query,
              })
            }
            let bookingExtrasConfiguration = result.configuration
            const environment = config.get("environment")
            if (environment && environment !== "") {
              if (bookingExtrasConfiguration.extraServices) {
                bookingExtrasConfiguration.extraServices = bookingExtrasConfiguration.extraServices.filter(
                  (es) => !es.environment || es.environment === environment,
                )
              }
            }

            parkingState.setState({
              bookingExtras: result.extras,
              bookingExtrasConfiguration,
              ajaxSpinnerActive: false,
              loadingFindExtrasForBooking: false,
            })
            return true // tell caller that this was a success
          })
          .catch((error) => {
            const text = axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingFindExtrasForBooking: false,
              loadingFindExtrasForBookingError: error,
            })
            if (text) trackError(text, error, "search")
          })
      },
    )
  }
}

export const addExtraToBooking = (extraProduct, extraOfferLineItem, callback) => {
  const textKeys = config.get("textKeys.dialog") || {}
  if (!parkingState.getState().loadingAddExtraToBooking) {
    const hasSelectedproduct =
      parkingState.getState().bookingResult &&
      parkingState.getState().bookingResult.activeBookingExtraProducts &&
      parkingState.getState().bookingResult.activeBookingExtraProducts.find((e) => e.product.id === extraProduct.id)

    console.debug(`extraProdutId: ${extraProduct.id}, extraOfferLineId:${extraOfferLineItem.id}`)

    const addProductOperation = () => {
      const data = {
        arrivalDate: getArrivalData(),
        departureDate: getDepartureData(),
        offerLineId: extraOfferLineItem.id,
        extraId: extraProduct.id,
      }

      axios
        .post(endpoint.ADD_EXTRAS(parkingState.getState().bookingResult.booking.guid), data)
        .then((result) => result.data)
        .then((result) => {
          if (result.message) {
            console.debug(result.message)
          }
          if (result.booking) {
            setGlobalState(
              {
                bookingResult: result,
                ajaxSpinnerActive: false,
                loadingAddExtraToBooking: false,
              },
              callback,
            )
          }
        })
        .catch((error) => {
          axiosErrorHandler(
            error,
            {
              ajaxSpinnerActive: false,
              loadingAddExtraToBooking: false,
              loadingAddExtraToBookingError: error,
            },
            {
              notFound: () => {
                genericModalOpen(
                  textKeys.invalidBookingForExtra || `<h3>Fejl</h3><p>Denne booking er i en tilstand hvor tillægsprodukter ikke kan ændres</p>`,
                )
              },
            },
          )
        })
    }

    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingAddExtraToBooking: true,
        loadingAddExtraToBookingError: undefined,
      },
      () => {
        if (hasSelectedproduct) {
          removeExtraFromBooking(extraProduct, addProductOperation, true)
        } else addProductOperation()
      },
    )
  }
}

export const removeExtraFromBooking = (extraProduct, callback, keepSpinner = false) => {
  if (!parkingState.getState().loadRemoveExtraFromBooking) {
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadRemoveExtraFromBooking: true,
        loadRemoveExtraFromBookingError: undefined,
      },
      () => {
        axios
          .delete(endpoint.REMOVE_EXTRAS(parkingState.getState().bookingResult.booking.guid) + "?extraId=" + extraProduct.id)
          .then((result) => result.data)
          .then((result) => {
            if (result.message) {
              console.debug(result.message)
            }
            if (result.booking) {
              setGlobalState(
                {
                  isLoaded: true,
                  bookingResult: result,
                  ajaxSpinnerActive: keepSpinner,
                  loadRemoveExtraFromBooking: false,
                },
                callback,
              )
            }
          })
          .catch((error) => {
            axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadRemoveExtraFromBooking: false,
              loadRemoveExtraFromBookingError: error,
            })
          })
      },
    )
  }
}

export const prepareForPayment = (bookingGuid, extensionId, history) => {
  if (!parkingState.getState().loadingPrepareForPayment) {
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingPrepareForPayment: true,
        loadingPrepareForPaymentError: undefined,
      },
      () => {
        const { billingAddress, vehicleInformation, flightInformation, consentInformation, bookingResult } = parkingState.getState()
        const agreements = { ...consentInformation }
        const customFieldValues = bookingResult?.booking?.customFieldValues || {}
        // backend doesn't have a field for terms_and_condition, so remove that
        if (Object.hasOwn(agreements, "terms_and_condition")) {
          delete agreements["terms_and_condition"]
        }
        const consents = config.get("consentContent").items.filter((consent) => consent.consentId != "terms_and_condition")
        const permissions = consents.map((item) => {
          return {
            permissionId: item.consentId || "",
            permissionVersion: item.consentVersion || "",
            permissionLanguage: "da",
            permissionGiven: agreements[item.consentId] || false,
          }
        })
        const data = {
          ...billingAddress,
          ...vehicleInformation,
          ...flightInformation,
          agreements,
          permissions,
          customFieldValues,
          membershipID: "",
        }
        axios
          .put(endpoint.PREPARE_PAYMENT(bookingGuid, extensionId), data)
          .then((result) => result.data)
          .then((result) =>
            setGlobalState(
              {
                bookingResult: result,
                loadingPrepareForPayment: false,
              },
              () => {
                initiatePayment(bookingGuid, extensionId, history)
              },
            ),
          )
          .catch((error) => {
            const text = axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingPrepareForPayment: false,
              loadingPrepareForPaymentError: error,
            })
            if (text) trackError(text, error, "payment")
          })
      },
    )
  }
}

export const prepareForPaymentMobilePay = (bookingGuid, extensionId, history) => {
  if (!parkingState.getState().loadingPrepareForPayment) {
    setGlobalState(
      {
        ajaxSpinnerActive: true,
        loadingPrepareForPayment: true,
        loadingPrepareForPaymentError: undefined,
      },
      () => {
        const { billingAddress, vehicleInformation, flightInformation, consentInformation, bookingResult } = parkingState.getState()
        const agreements = { ...consentInformation }
        const customFieldValues = bookingResult?.booking?.customFieldValues || {}
        // backend doesn't have a field for terms_and_condition, so remove that
        if (Object.hasOwn(agreements, "terms_and_condition")) {
          delete agreements["terms_and_condition"]
        }
        const consents = config.get("consentContent").items.filter((consent) => consent.consentId != "terms_and_condition")
        const permissions = consents.map((item) => {
          return {
            permissionId: item.consentId || "",
            permissionVersion: item.consentVersion || "",
            permissionLanguage: "da",
            permissionGiven: agreements[item.consentId] || false,
          }
        })
        const data = {
          ...billingAddress,
          ...vehicleInformation,
          ...flightInformation,
          agreements,
          permissions,
          customFieldValues,
          membershipID: "",
        }
        axios
          .put(endpoint.PREPARE_PAYMENT(bookingGuid, extensionId), data)
          .then((result) => result.data)
          .then((result) =>
            setGlobalState(
              {
                bookingResult: result,
                loadingPrepareForPayment: false,
              },
              () => {
                initiatePaymentMobilePay(bookingGuid, extensionId, history)
              },
            ),
          )
          .catch((error) => {
            const text = axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingPrepareForPayment: false,
              loadingPrepareForPaymentError: error,
            })
            if (text) trackError(text, error, "payment")
          })
      },
    )
  }
}

export const initiatePaymentMobilePay = (bookingGuid, extensionId, history) => {
  const textKeys = config.get("textKeys.dialog") || {}
  let isExtension = extensionId > 0 ? true : false
  if (!parkingState.getState().loadingInitiatePayment) {
    setGlobalState(
      {
        loadingInitiatePayment: true,
        loadingInitiatePaymentError: undefined,
        ajaxSpinnerActive: true,
        //    ajaxSpinnerTransparent: true,
      },
      () => {
        axios
          .post(
            endpoint.INITIATE_PAYMENT_MP() +
              "?bookingGuid=" +
              encodeURIComponent(bookingGuid) +
              "&extensionId=" +
              encodeURIComponent(extensionId) +
              "&languageCode=" +
              endpoint.locale() +
              `${parkingState.getState().flightId ? `&flightId=${parkingState.getState().flightId}` : ""}`,
          )
          .then((result) => {
            if (result.status === 202) {
              setGlobalState(
                {
                  ajaxSpinnerActive: false,
                  ajaxSpinnerTransparent: undefined,
                  loadingPayWithWallet: false,
                },
                () => {
                  history.push({
                    pathname: path.RECEIPT(),
                    search: `?bguid=${bookingGuid}&source=${isExtension ? "extension" : parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOW ? "amend" : "standard"}`,
                  })
                },
              )
              return
            }
            console.debug(result.data)
            return result.data
          })
          .then((result) => {
            new Wallet().open(result.walletSessionId)
            const trackingProps = {
              arrivalDate: parkingState.getState().arrivalDate,
              departureDate: parkingState.getState().departureDate,
            }
            if (parkingState.getState().consentInformation.privacyOptIn) {
              tracking.trackPermissionOptIn(trackingProps, "newsletter", "parking purchase")
            }
            if (parkingState.getState().consentInformation.emailOptIn) {
              tracking.trackPermissionOptIn(trackingProps, "related products", "parking purchase")
            }
          })
          .catch((error) => {
            const text = axiosErrorHandler(
              error,
              {
                ajaxSpinnerActive: false,
                ajaxSpinnerTransparent: undefined,
                loadingInitiatePayment: false,
                loadingInitiatePaymentError: error,
              },
              {
                badRequest: (s) => {
                  const data = JSON.parse(s)
                  if (data.errorMessage === "PAYMENT_EXISTS") {
                    genericModalOpen(
                      textKeys.paymentInProgress ||
                        `<h3>Ordren er under behandling</h3><p>Der er allerede en betaling i gang for denne ordre</p><p>Du vil modtage en ordrebekræftelse på email indenfor få minutter</p>`,
                      () => {
                        history.push({
                          pathname: path.RECEIPT(),
                          search: `?bguid=${bookingGuid}`,
                        })
                      },
                    )
                  }
                },
              },
            )
            if (text) trackError(text, error, "payment")
          })
      },
    )
  }
}

export const initiatePayment = (bookingGuid, extensionId, history) => {
  const textKeys = config.get("textKeys.dialog") || {}
  let isExtension = extensionId > 0 ? true : false
  if (!parkingState.getState().loadingInitiatePayment) {
    setGlobalState(
      {
        loadingInitiatePayment: true,
        loadingInitiatePaymentError: undefined,
        ajaxSpinnerActive: true,
        //    ajaxSpinnerTransparent: true,
      },
      () => {
        axios
          .post(
            endpoint.INITIATE_PAYMENT_V2() +
              "?bookingGuid=" +
              encodeURIComponent(bookingGuid) +
              "&extensionId=" +
              encodeURIComponent(extensionId) +
              "&languageCode=" +
              endpoint.locale() +
              "&affiliateCode=" +
              parkingState.getState().affiliateCode +
              `${parkingState.getState().flightId ? `&flightId=${parkingState.getState().flightId}` : ""}`,
          )
          .then((result) => {
            if (result.status === 202) {
              getBookingByGuid(bookingGuid, () => {
                // force reciept reload after no-pay handling in backend
                setGlobalState(
                  {
                    ajaxSpinnerActive: false,
                    ajaxSpinnerTransparent: undefined,
                    loadingPayWithWallet: false,
                    bookingResult: parkingState.getState().manageBookingResult,
                  },
                  () => {
                    history.push({
                      pathname: path.RECEIPT(),
                      search: `?bguid=${bookingGuid}&source=${isExtension ? "extension" : parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOW ? "amend" : "standard"}`,
                    })
                  },
                )
                return
              })
            }
            return result.data
          })
          .then((result) => {
            setGlobalState(
              {
                paymentData: result,
                paymentModalActive: true,
                ajaxSpinnerActive: false,
                ajaxSpinnerTransparent: undefined,
                loadingInitiatePayment: false,
              },
              () => {
                // there is only paymentdata in state if the result is not a no-pay scenario
                if (parkingState.getState().paymentData) {
                  // remove this to revert back to payment modal
                  tracking.trackBamboraShow(parkingState.getState().bookingResult)
                  new RedirectCheckout(parkingState.getState().paymentData.verificationToken)
                }
              },
            )
            const trackingProps = {
              arrivalDate: parkingState.getState().arrivalDate,
              departureDate: parkingState.getState().departureDate,
            }
            if (parkingState.getState().consentInformation.privacyOptIn) {
              tracking.trackPermissionOptIn(trackingProps, "newsletter", "parking purchase")
            }
            if (parkingState.getState().consentInformation.emailOptIn) {
              tracking.trackPermissionOptIn(trackingProps, "related products", "parking purchase")
            }
          })
          .catch((error) => {
            const text = axiosErrorHandler(
              error,
              {
                ajaxSpinnerActive: false,
                ajaxSpinnerTransparent: undefined,
                loadingInitiatePayment: false,
                loadingInitiatePaymentError: error,
              },
              {
                badRequest: (s) => {
                  const data = JSON.parse(s)
                  if (data.errorMessage === "PAYMENT_EXISTS") {
                    genericModalOpen(
                      textKeys.paymentInProgress ||
                        `<h3>Ordren er under behandling</h3><p>Der er allerede en betaling i gang for denne ordre</p><p>Du vil modtage en ordrebekræftelse på email indenfor få minutter</p>`,
                      () => {
                        history.push({
                          pathname: path.RECEIPT(),
                          search: `?bguid=${bookingGuid}`,
                        })
                      },
                    )
                  }
                },
              },
            )
            if (text) trackError(text, error, "payment gateway")
          })
      },
    )
  }
}

const apiHelper = {
  findBooking,
  findUpsaleForBooking,
  createQueryStrings,
  axiosErrorHandler,
  modifyBookingInformation,
  performParkingSearch,
  performChangeBookingSearch,
  performChangeBookingTime,
  performChangeBookingExitTime,
  addExtraToBooking,
  removeExtraFromBooking,
  findExtrasForBooking,
  resendNextAvailableBookingConfirmation,
  resendBookingReceipt,
  executeUpsaleForBooking,
  getBookingByGuid,
  cancelBooking,
  handleEmailOfferUpgrade,
  handleReservation,
  handleReservationInternal,
  handleBookingExtension,
  prepareForPayment,
  prepareForPaymentMobilePay,
  initiatePaymentMobilePay,
  initiatePayment,
}

export default apiHelper
